'use strict';

/**
 * [options internal helper function]
 * @param  {[object]} opts     [description]
 * @param  {[object]} defaults [description]
 * @return {[object]}          [description]
 */
function options(opts, defaults) {
    return $.extend({}, defaults, opts);
}

/**
 * [defaultLightbox]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function defaultLightbox(scope){
    $(scope).each(function () {
        let elm = $(this),
            opts = options(elm.data(), {
                padding: 10
            });

        elm.fancybox(opts);
    });
}

/**
 * [elasticLightbox with elastic open and close effect]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function elasticLightbox(scope){
    $(scope).each(function () {
        var elm = $(this),
            opts = options(elm.data(), {
                padding: 10,
                openEffect: 'elastic',
                openSpeed: 150,
                closeEffect: 'elastic',
                closeSpeed: 150,
                closeClick: true,
                helpers: {
                    overlay: null,
                    title: {
                        type: 'over'
                    }
                }
            });

        elm.fancybox(opts);
    });
}

/**
 * [noOverlayLightbox without overlay]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function noOverlayLightbox(scope){
    $(scope).each(function () {
        var elm = $(this),
            opts = options(elm.data(), {
                padding: 10,
                helpers: {
                    overlay: null,
                    title: {
                        type: 'over'
                    }
                }
            });

        elm.fancybox(opts);
    });
}

/**
 * [galleryLightbox makes a group gallery]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function galleryLightbox(scope){
    $(scope).fancybox({
        padding: 10,
        groupAttr: 'data-gallery-group',
        helpers: {
            title: {
                type: 'over'
            }
        },
        beforeLoad: function () {
            this.title = (this.index + 1) + ' / ' + this.group.length + (this.title ? ' - ' + this.title : '');
        }
    });
}

/**
 * [galleryThumbsLightbox makes a gallery with thumbnails]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function galleryThumbsLightbox(scope){
    $(scope).fancybox({
        padding: 10,
        helpers: {
            thumbs: {
                width: 50,
                height: 50
            }
        }
    });
}

/**
 * [iframeLightbox makes a lightbox with iframe]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function iframeLightbox(scope){
    $(scope).each(function () {
        var elm = $(this),
            opts = options(elm.data(), {
                width: '75%',
                height: '75%',
                padding: 10,
                type: 'iframe',
                iframe: {
                    scrolling: 'auto',
                    preload: true
                },
                autoSize: false
            });

        elm.fancybox(opts);
    });
}

/**
 * [flashLightbox makes a lightbox with swf/flash file]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function flashLightbox(scope){
    $(scope).each(function () {
        var elm = $(this),
            opts = options(elm.data(), {
                padding: 10,
                type: 'swf',
                swf: {
                    wmode: 'transparent',
                    allowfullscreen: 'true',
                    allowscriptaccess: 'always'
                },
                autoSize: false
            });

        elm.fancybox(opts);
    });
}

/**
 * [ajaxLightbox makes an ajax lightbox]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function ajaxLightbox(scope){
    $(scope).each(function () {
        var elm = $(this),
            opts = options(elm.data(), {
                width: 500,
                height: 500,
                padding: 10,
                type: 'ajax',
                autoSize: false
            });

        elm.fancybox(opts);
    });
}

/**
 * [inlineLightbox makes a ligthbox of inline content]
 * @param  {[string]}   scope   [css selector]
 * @return {[undefined]}        [nothing returned]
 */
export function inlineLightbox(scope){
    $(scope).each(function () {
        var elm = $(this),
            opts = options(elm.data(), {
                padding: 20,
                type: 'inline',
                title: false,
                minHeight: 0,
                beforeLoad: function () {
                    var url = this.href;
                    if (!url) {
                        url = $(this).data('href');
                    }
                    var hash = url.substring(url.indexOf('#'));

                    this.href = hash;
                }
            });

        elm.fancybox(opts);
    });
}

/**
 * [videoLightbox description]
 * @param  {[type]} scope [description]
 * @return {[type]}       [description]
 */
export function videoLightbox(scope){
    $(scope).each(function () {
        var elm = $(this),
            opts = options(elm.data(), {
                padding: 0,
                openEffect: 'none',
                closeEffect: 'none',
                height: 455,
                helpers: {
                    media: {}
                }
            });

        elm.fancybox(opts);
    });
}

/**
 * [init initilizes all lightboxes]
 * @param  {[object]} scopes    [a object keys as function names and value as selectors]
 * @return {[undefined]}        [nothing returned]
 */
export function init(scopes){
    for(let scope in scopes){
        this[scope].call(this, scopes[scope]);
    }
}
